import type { PaymentIntentStatus } from '@/api/models';

/** Poll cadence for the live timeline (run-6's fixed contract: 3s). */
export const TIMELINE_POLL_INTERVAL_MS = 3000;

/** Statuses that end a bench payment's lifecycle — polling stops once one of these is reached. */
const TERMINAL_STATUSES: readonly PaymentIntentStatus[] = ['captured', 'failed', 'cancelled', 'expired'];

export function isTerminalStatus(status: PaymentIntentStatus): boolean {
  return TERMINAL_STATUSES.includes(status);
}
